import React, { useEffect, useState, useRef } from "react";
import PaymentSummary from "src/business-types/laundry/modules/home/Payment/components/PaymentSummary";
import Payment from "src/business-types/laundry/modules/home/Payment/Payment";
import { ModalWrapper } from "../../../../../shared/components/ModalWrapper";
import { PaymentProps } from ".././Payment/types/payment";
import { useOrderProcessing } from "src/business-types/laundry/modules/home/Payment/hooks/useOrderProcessing";
import Done from "../Done/Done";
import { useUser } from "src/shared/context/UserContext";
import OverCreditPermission, { ApprovalResult } from "./creditControl/OverCreditPermission";

const PayLater: React.FC<PaymentProps> = ({ cartId, backHome, backHomepay, editedAmounts }) => {
  const {
    cartProducts,
    customer,
    cartLoading,
    backToPayment,
    setBackToPayment,
    paymentSuccess,
    orderId,
    currentTime,
    roundAmount,
    handleOrderSuccess,
    buttonLoading,
    overCreditLimit,
    approvalContacts,
    requestApproval,
    finishProcess,
    IncreaseCreditLimit,
    draftStatusUpdate,
  } = useOrderProcessing(cartId, editedAmounts);

  const { userConfigration, creditLimit } = useUser();
  const toBoolean = (value: any) => value === true || value === "true";
  const deliveryFeeEnabled = toBoolean(userConfigration?.deliveryFeeEnabled);

  // ✅ Over-credit approval flow state
  const [approvalLoading, setApprovalLoading] = useState(false);
  const [approvalSuccess, setApprovalSuccess] = useState(false);
  const successTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (finishProcess) {
      backHomepay("done");
    }
  }, [finishProcess]);

  // ✅ Cleanup timer on unmount
  useEffect(() => {
    return () => {
      if (successTimerRef.current) clearTimeout(successTimerRef.current);
    };
  }, []);

  if (backToPayment) return <Payment cartId={cartId} backHomepay={backHomepay} backHome={backHome} editedAmounts={editedAmounts} />;

  if (paymentSuccess) return <Done orderid={orderId} onFinish={() => backHomepay("done")} customer={customer} />;

  const checkCreditControl = async (gettingData: ApprovalResult) => {
    if (gettingData.type === "contacts") {
      try {
        setApprovalLoading(true);
        await requestApproval(gettingData.selectedContacts);
        setApprovalLoading(false);
        setApprovalSuccess(true);

        // ✅ Auto-close after 3 seconds
        successTimerRef.current = setTimeout(() => {
          setApprovalSuccess(false);
          backHome("done");
        }, 3000);
      } catch (err) {
        setApprovalLoading(false);
        // Optionally show error toast here
      }
      return;
    }
    if (gettingData.type === "increase-credit") {
      IncreaseCreditLimit(gettingData.newLimit);
      return;
    }
    if (gettingData.type === "approve") {
      draftStatusUpdate("Accepted");
      return;
    }
  };

  const currentCerditLimit = userConfigration.creditControlEnabled && customer?.defaultCreditControl === false ? Number(customer?.creditLimit?.defaultLimit) : Number(creditLimit) || 0;

  return (
    <ModalWrapper
      title={overCreditLimit ? "Over Credit Permission" : "Payment summary"}
      onClose={() => backHome("false")}
      showBackButton
      onBack={() => setBackToPayment(true)}
      className="min-w-[480px] text-center"
      width="max-w-xl w-full"
      positionClass="top-0 left-0 right-0 mt-10 h-full"
    >
      {!overCreditLimit ? (
        <PaymentSummary
          products={cartProducts}
          customer={customer}
          paymentMethod="Buy on Credit"
          receivedAmount={0}
          showBalance={true}
          currentTime={currentTime}
          onAmountChange={() => {}}
          onToggleBalance={() => {}}
          roundAmount={roundAmount}
          onCancel={() => backHome("false")}
          onComplete={() => handleOrderSuccess("Buy on Credit")}
          isLoading={cartLoading || !customer}
          backHome={backHome}
          buttonLoading={buttonLoading}
          deliveryFeeEnabled={deliveryFeeEnabled}
        />
      ) : (
        <OverCreditPermission
          approvalContacts={approvalContacts}
          onCancel={() => backHome("false")}
          onConfirm={checkCreditControl}
          currentCreditLimit={currentCerditLimit || 0}
          loading={approvalLoading}
          success={approvalSuccess}
        />
      )}
    </ModalWrapper>
  );
};

export default PayLater;
